import { v4 as uuidv4 } from "uuid";

export const updateEdges = (data) => {
  return (edges) => {
    return edges.map((edge) => {
      if (edge.id === data.id) {
        return {
          ...edge,
          data: {
            ...edge.data,
            ...data.data,
          },
        };
      }
      return edge;
    });
  };
};

export const addNode = (data) => {
  const id = uuidv4();

  const {
    edges,
    nodes,
    setNodes,
    setEdges,
    parentData,
    nodeData,
    type,
    dataNode,
  } = data;
  const newNode = [
    {
      id: `${dataNode.data.parentData.type}-${id}`,
      position: {
        x: dataNode.data.parentData.position.x + 200,
        y: dataNode.data.parentData.position.y,
      },
      type,
      data: {
        parentData,
        edges,
        nodes,
        setNodes,
        setEdges,
      },
    },
  ];
  const newEdge = [
    {
      id: `add-edge-${newNode[0].id}`,
      source: dataNode.data.parentData.id,
      target: newNode[0].id,
      targePosition: "left",
      sourcePosition: "right",
      type: "addButton",
      animated: true,
      data: {
        parentData: {
          id: `${dataNode.data.parentData.type}-${id}`,
          edgeId: `add-edge-${dataNode.data.parentData.type}-${id}`,
          type: nodeData.type,
          principalParentType: nodeData.type,
          position: {
            x: dataNode.data.parentData.position.x + 200,
            y: dataNode.data.parentData.position.y,
          },
        },
        nodeData,
        edges,
        nodes,
        setNodes,
        setEdges,
      },
    },
  ];
  if (!dataNode.data.parentData.principalParentType) {
    newNode.push({
      id: `buttonAdd-${nodeData.type}`,
      position: {
        x: dataNode.data.parentData.position.x + 200,
        y: dataNode.data.parentData.position.y,
      },
      type: "buttonAdd",
      data: {
        parentData: {
          id: `${dataNode.data.parentData.type}-${id}`,
          type: nodeData.type,
          principalParentType: nodeData.type,
          position: {
            x: dataNode.data.parentData.position.x + 200,
            y: dataNode.data.parentData.position.y,
          },
        },
        nodeData,
        edges,
        nodes,
        setNodes,
        setEdges,
      },
    });
    newEdge.push({
      id: `buttonAdd-edge-${nodeData.type}`,
      source: newNode[0].id,
      target: newNode[1].id,
      type: "default",
      animated: true,
    });
  }

  setNodes((prev) => [
    ...prev.map((node) => {
      if (
        node.id === `buttonAdd-${dataNode.data.parentData.principalParentType}`
      ) {
        return {
          ...node,
          data: {
            position: {
              x: dataNode.data.parentData.position.x + 200,
              y: dataNode.data.parentData.position.y,
            },
            parentData: {
              id: `${dataNode.data.parentData.type}-${id}`,
              type: nodeData.type,
              principalParentType: nodeData.type,
              position: {
                x: dataNode.data.parentData.position.x + 200,
                y: dataNode.data.parentData.position.y,
              },
            },
            nodeData,
            edges,
            nodes,
            setNodes,
            setEdges,
          },
        };
      }
      return node;
    }),
    ...newNode,
  ]);
  setEdges((prevEdge) => [
    ...(prevEdge.map((edge) => {
      if (
        edge.id ===
        `buttonAdd-edge-${dataNode.data.parentData.principalParentType}`
      ) {
        return { ...edge, source: newNode[0].id };
      }
      return edge;
    }) || []),
    ...newEdge,
  ]);
};

export const updateToAddNodes = (data) => {
  const id = uuidv4();
  const {
    edges,
    nodes,
    setNodes,
    setEdges,
    parentData,
    nodeData = { type: "entryIntentNode" },
  } = data;

  const newNode = {
    id: `${parentData.type}-${id}`,
    position: { x: parentData.position.x + 200, y: parentData.position.y },
    type: nodeData.type,
    targePosition: "left",
    sourcePosition: "right",
    data: {
      parentData,
      edges,
      nodes,
      setNodes,
      setEdges,
    },
  };

  const newEdge = {
    id: `add-edge-${id}`,
    target: parentData.id.includes("buttonAdd") ? newNode.id : parentData.id,
    source: parentData.id.includes("buttonAdd") ? parentData.id : newNode.id,
    type: "addButton",
    animated: true,
    data: {
      parentData: {
        id: `${parentData.type}-${id}`,
        edgeId: `add-edge-${parentData.type}-${id}`,
        type: nodeData.type,
        principalParentType: nodeData.type,
        position: {
          x: parentData.position.x + 200,
          y: parentData.position.y,
        },
      },
      nodeData,
      edges,
      nodes,
      setNodes,
      setEdges,
    },
  };

  setNodes((prev) => [...prev.filter((i) => i.id !== "buttonAdd-1"), newNode]);
  setEdges((prevEdge) => [
    ...(prevEdge
      .filter((i) => i.id !== "add-edge-1")
      .map((edge) => {
        if (edge.id === parentData.edgeId) {
          return { ...edge, target: newNode.id };
        }
        return edge;
      }) || []),
    newEdge,
  ]);
};
